// import case names
import { get } from 'lodash';
import { DASHBOARD_SUB_ROUTES } from 'constants/route-paths';
import queryString from 'query-string';
import { ORIGIN } from 'constants/common';

/**
 * @type {function}
 * @desc Resolvers are pure functions used for resolving templates (React components) or to transform some data.
 * A resolver function takes an `id` and an optional `payload` and returns a `result`.
 * Based on `switch` cases inside this function, correct `result` should be returned.
 * @param {object} payload
 * @example
 * import { getBackRouteForCheckoutResolver } from 'resolvers/getBackRouteForCheckout';
 */
export const getBackRouteForCheckoutResolver = ( { queryParams = {}, queryState = {} } ) => {

    const origin = get( queryParams, 'origin' );

    switch( origin ) {

        case ORIGIN.MEMBER_MANAMGENT: {

            return {
                pathname: DASHBOARD_SUB_ROUTES.MEMBER_MANAGEMENT,
                state: {  memberId: queryState.memberId, patientId:  queryState.patientId }
            };
        }

        case ORIGIN.ORDER_DETAIL : {

            return {
                pathname: DASHBOARD_SUB_ROUTES.ORDER_DETAIL,
                search: queryString.stringify( {
                    orderId: queryParams.orderId
                } ),
                state: {  memberId: queryState.memberId, patientId:  queryState.patientId }
            };
        }

        default : {
            return {
                pathname: DASHBOARD_SUB_ROUTES.MEMBER_MANAGEMENT,
                state: {  memberId: queryState.memberId, patientId:  queryState.patientId }
            };
        }
    }
};
